import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeFilters } from 'actions/search';
import { Link } from 'react-router-dom';
import { getHighlightedText } from '../utils';
import s from '../style';

@connect(null, { changeFilters })
export default class Buildings extends Component {
  onItemClick = () => {
    this.props.closeModal();
  }

  render() {
    const {
      name,
      items,
      isShown,
      highlight
    } = this.props;

    if (isShown && items.length) {
      return (
        <div className={s.resultSection}>
          <div className={s.resultSectionTitle}>{name} ({items.length})</div>
          {items.map(item => (
            <div
              onClick={this.onItemClick}
              key={item.id}
              className={s.resultItemWrap}
            >
              <Link
                to={`/building/${item.id}`}
                className={s.resultItem}
              >
                <div className={s.resultItemTitle}>{getHighlightedText(item.name, highlight)}</div>
                <div className={s.resultItemDescrip}>
                  {item.subregion && <div>{item.subregion}, </div>}
                  <div>{` ${item.address}`}</div>
                </div>
              </Link>
            </div>
            ))}
        </div>
      );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/SearchFullscreen/Content/Buildings/Buildings.js